import { useSSNavigate } from '../../../navigation/ss-navigate.hook';
import { useEffect, useState } from 'react';
import { useApp } from '../../../hook/app.hook';
import { TestService } from '../../../service/test.service';
import { SecurityManager } from '../../../security/security-manager';
import { useWindow } from '../../../util/window-helper';

export const useInitTest = () => {
  const { openInvalidLink } = useSSNavigate();
  const { testInitData, addTestData } = useApp();
  const { isMobile } = useWindow();

  const [loading, setLoading] = useState(true);

  const fetchTest = async () => {
    const preview = SecurityManager.getPreview();
    const [data] = await TestService.startTestById(testInitData.id, preview);

    if (data) {
      addTestData(data, isMobile);
    } else {
      openInvalidLink();
    }

    setLoading(false);
  };

  useEffect(() => {
    fetchTest();
  }, []);

  return {
    loading,
  };
};
